import axios from 'axios'
import store from '../../store/index'

const state = {
  payment: {},
  paymentSuccess: {},
}

const mutations = {
  payment_data (state, payment) {
    state.payment = payment
  },
  payment_success_data (state, payment) {
    const inside = JSON.parse(localStorage.getItem('inside'))
    inside.subscription = payment.subscription
    inside.companySubscription = payment.companySubscription
    inside.subscriptionLimits = payment.subscriptionLimits
    // localStorage.setItem('inside', JSON.stringify(inside))
    store.commit('auth_success', JSON.stringify(inside))
    state.paymentSuccess = payment
  },
}

const actions = {
  makePayment ({ commit }, payment) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/payments',
        data: payment,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  makeFreePayment ({ commit }, payment) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/payments/free',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  completePayment ({ commit }, payment) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/payments',
        data: payment,
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  completePaymentPack ({ commit }, payment) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/payments/pack',
        data: payment,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          console.log('completePaymentPack')
          console.log(resp)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getPayment ({ commit }, paymentId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/payments?id=' + paymentId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('payment_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getPaymentSuccess ({ commit }, paymentId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/payments/success?id=' + paymentId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('payment_success_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getClientSecret ({ commit }, paymentRequest) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/payments/clientSecret',
        data: paymentRequest,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
